import React from 'react'
import PropTypes from 'prop-types'
import Container from '@components/Container'
import { CONTAINER_STYLE } from '@helpers/constants'
import GridColumns from '@components/GridColumns'

import './style.css'

const SideBarPage = ({ children }) => {
    return (
        <div className={'sideBarPage'}>
            <Container size={CONTAINER_STYLE.DESKTOP}>
                <GridColumns cols={3}>{children}</GridColumns>
            </Container>
        </div>
    )
}

SideBarPage.propTypes = {
    children: PropTypes.any,
}

SideBarPage.Content = (props) => {
    const { children, setRef } = props

    return (
        <div
            className={'pl-8 pb-4 relative'}
            ref={(ref) => setRef ? setRef(ref) : null}
        >
            {children}
        </div>
    )
}

SideBarPage.Content.propTypes = {
    children: PropTypes.any,
}

export default SideBarPage
